{
    "TeamsAuth_UserIntro": "Hallo {},",
    "TeamsAuth_UserIntro_2": "Akixi für MS Teams bittet um Zugriff auf Ihren Microsoft Entra Tenant",
    "TeamsAuth_AdminConsent": "Erteilung der Zustimmung der Verwaltung",
    "TeamsAuth_Authorise": "Autorisieren Sie",
    "TeamsAuth_ConsentedMessage": "Admin Consent erteilt, bitte klicken Sie auf Authorise um fortzufahren",
    "TeamsAuth_AuthorisedMessage": "Bewilligung erteilt",
    "TeamsAuth_Decline": "Rückgang",
    "TeamsAuth_Error_Unknown": "Es ist ein nicht erkannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Systemadministrator.",
    "NAME": "TeamsAuth"
}